export const UPDATE_TRAINING = 'UPDATE_TRAINING';
export const UPDATE_SINGLE_TRAINING = 'UPDATE_SINGLE_TRAINING';
export const CLEAR_TRAINING = 'CLEAR_TRAINING';
// TODO We are not yet using this anywhere
export const AXUMIN_ID = 1;
export const RHPSMA_ID = 2;
